import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "../Base";
import ClientUserInfo from "@/models/Agents/UserInfo";

export enum AgentsUserInfoMixinTags {
  Current = "agents_user_info_current",
}

@Component
export default class AgentsUserInfoMixin extends Base {
  currentAgentUserInfos(profileSlug: string): Promise<ClientUserInfo> {
    const url = API_ENDPOINT + `/${profileSlug}/agents/user_infos/current.json`;
    return this.$store.dispatch("http/request", {
      tag: AgentsUserInfoMixinTags.Current,
      url,
      method: "GET",
    });
  }
}
